import Loadable from '../../components/loadable';

const DailyTakingsReport = Loadable({
  loader: () => import('../../pages/reports/daily_takings_report'),
  type: 'block',
});

angular.module('gym').value('DailyTakingsReport', DailyTakingsReport);
